import { render, staticRenderFns } from "./CRelationType.vue?vue&type=template&id=0a26d29a"
import script from "./CRelationType.vue?vue&type=script&lang=js"
export * from "./CRelationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a26d29a')) {
      api.createRecord('0a26d29a', component.options)
    } else {
      api.reload('0a26d29a', component.options)
    }
    module.hot.accept("./CRelationType.vue?vue&type=template&id=0a26d29a", function () {
      api.rerender('0a26d29a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/CRelationType.vue"
export default component.exports